export default __webpack_public_path__ + "static/media/sidehop_thumb.2459ff54.png";